function useShallowSetState(setter) {
  return (next) => setter((prev) => shallow(prev, next));
}
function shallow(prev, next) {
  for (const key in next) {
    if (prev[key] !== next[key]) {
      return { ...prev, ...next };
    }
  }
  return prev;
}
export {
  useShallowSetState
};
//# sourceMappingURL=useShallowSetState.js.map
